export default __webpack_public_path__ + "media/zurb/img/events/wired/rcs/rcs-photos-90d53497fca9cd8325ebe8555a158da3.png";